// extracted by mini-css-extract-plugin
export default {"colFlex":"CreditDebit_colFlex__Jj9p3","totalRow":"CreditDebit_totalRow__OCtna","doNotIncludeSpan":"CreditDebit_doNotIncludeSpan__oO1xk"};